import React from "react";

import MapIcon from "./icons/MapIcon";
import EmailIcon from "./icons/EmailIcon";
import PhoneIcon from "./icons/PhoneIcon";

const Contact = ({contactRef}) => {
    return(
        <div ref={contactRef} className="md:mt-20 md:p-0 Contact p-[20px] mb-[40px]">
            <p className="md:text-6xl font-bold text-4xl">Contact<span className="text-[#ffd739]">_</span></p>
            <div className="mt-4 flex flex-row items-center">
                <p className="text-2xl font-semibold mr-4"><MapIcon /></p>
                <p className="md:text-xl text-lg">Tanjay City, Negros Oriental, Philippines</p>
            </div>

            <div className="mt-4 flex flex-row items-center">
                <p className="text-2xl font-semibold mr-4"><EmailIcon /></p>
                <p className="md:text-xl text-lg">smarkdhem@gmail.com</p>
            </div>

            <div className="mt-4 flex flex-row items-center">
                <p className="text-2xl font-semibold mr-4"><PhoneIcon /></p>
                <p className="md:text-xl text-lg">+639068684149</p>
            </div>

        </div>
    )
}

export default Contact;